module.exports = "<div class=header-bar__contents> <div class=header-bar__contents--left> <div class=button-container> <volume-button ng-if=$ctrl.AppServices.DataManager.config.settings.audio.isAudioEnabled></volume-button> </div> </div> <div class=header-bar__contents--center> <img ng-src={{$ctrl.AppServices.DataManager.config.settings.localizedPath}}images/localized/top_logo.png alt=\"\"/> </div> <div class=header-bar__contents--right> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/header-bar/header-bar.html
 ** module id = 80
 ** module chunks = 0
 **/